import { Component, OnInit, Input } from '@angular/core';
import { AdvtService } from './../../_services/advt.service';
import { EventEmitter } from 'protractor';

@Component({
  selector: 'app-dashboard-free-sidemenu',
  templateUrl: './dashboard-free-sidemenu.component.html',
  styleUrls: ['./dashboard-free-sidemenu.component.css']
})
export class DashboardFreeSidemenuComponent implements OnInit {
  @Input() type: string;
  @Input() type2: string;

  listCategories: any;
  public selectedItem='home';
  public selectedItem1;

  constructor(private advtService: AdvtService) { }

  ngOnInit() {
    this.advtService.getAllCategories().subscribe(
      data => {
        this.listCategories = data;
      }, error => {
      });
    if (localStorage.getItem('currentMenu')) {
      this.selectedItem = localStorage.getItem('currentMenu');
    }else{
      localStorage.setItem('currentMenu','home');
      this.selectedItem = localStorage.getItem('currentMenu');
    }


    if (!this.selectedItem) {
      this.selectedItem = 'home';
    }
  }

  listClick(event, newValue) {
    event.target.classList.remove('class1'); // To Remove
    if(newValue == localStorage.getItem("currentMenu")){
      localStorage.setItem("currentMenu", '');
      this.selectedItem = '';
    }else{
      localStorage.setItem("currentMenu", newValue);
      this.selectedItem = newValue;  // don't forget to update the model here
      // ... do other stuff here ...
    }
  }
  dtype(data){
    this.type = data ;
  }

  listClick1(event, newValue) {
    if(newValue == localStorage.getItem("currentMenu")){
      localStorage.setItem("currentMenu", '');
      this.selectedItem1 = '';
    }else{
      localStorage.setItem("currentMenu", newValue);
      this.selectedItem1 = newValue;  // don't forget to update the model here
      // ... do other stuff here ...
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/authorized-data/dashboard-free-sidemenu/dashboard-free-sidemenu.component.ts